import axios from "axios";
export default {
  getText: function(html) {
    var divContainer = document.createElement("div");
    divContainer.innerHTML = html;
    return divContainer.textContent || divContainer.innerText || "";
  },

  randomNumbers: function(arr, count = 3) {
    if (arr.length < count) {
      console.error("Array does not have enough elements.");
      return null;
    }

    // Shuffle the array (Fisher-Yates algorithm)
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    // Take the first 'count' elements
    return arr.slice(0, count);
  },
  calculateRatings: function(feedbacks) {
    let totalStars = 0;
    let voters = feedbacks.length;

    if (voters === 0) {
      return 0;
    }
    feedbacks.map((item) => (totalStars += item.rating));
    return (totalStars / voters).toFixed(1);
  },

  isValidEmail: function(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  arrayUnique: function(myArray) {
    return [...new Set(myArray)];
  },

  validatePassword: function(str) {
    let length = false,
      specialChar = false,
      numericNumber = false,
      lowercaseChar = false,
      uppercaseChar = false,
      status = false;

    let lowerCaseLetters = /[a-z]/g,
      upperCaseLetters = /[A-Z]/g,
      specialCharCheck = /[^\w\s]/gi,
      numbers = /[0-9]/g;

    let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(\W|_)).{6,}$/g;

    if (lowerCaseLetters.test(str) === true) {
      lowercaseChar = true;
    }

    if (specialCharCheck.test(str) === true) {
      specialChar = true;
    }

    if (numbers.test(str) === true) {
      numericNumber = true;
    }

    if (upperCaseLetters.test(str) === true) {
      uppercaseChar = true;
    }

    if (str.length >= 8) {
      length = true;
    }

    if (regex.test(str) === true) {
      status = true;
    }

    return {
      length: length,
      specialChar: specialChar,
      numericNumber: numericNumber,
      uppercaseChar: uppercaseChar,
      lowercaseChar: lowercaseChar,
      status: status,
    };
  },

  checkFormValidity: function(form_id) {
    let form = document.getElementById(form_id);
    console.log("id = ", form_id);
    console.log("form = ", form);
    // Parcourir tous les champs du formulaire
    for (let i = 0; i < form.elements.length; i++) {
      let field = form.elements[i];

      if (field.checkValidity()) {
        // Le champ est valide, supprimer la classe "is-invalid" s'il est présent
        field.classList.remove("is-invalid");
        // Ajouter la classe "is-valid" au champ valide
        //field.classList.add('is-valid');
      } else {
        // Le champ est invalide, supprimer la classe "is-valid" s'il est présent
        //field.classList.remove('is-valid');
        // Ajouter la classe "is-invalid" au champ invalide
        field.classList.add("is-invalid");
        console.log("field is", field);
      }
    }
    if (!form.checkValidity()) form.reportValidity();
    return form.checkValidity();
  },

  formatDate: function(dateString, locale, withTime = false, numeric = false) {
    let options;
    if (withTime) {
      if (numeric)
        options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        };
      else
        options = {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        };
    } else {
      if (numeric)
        options = { year: "numeric", month: "2-digit", day: "2-digit" };
      else options = { year: "numeric", month: "long", day: "numeric" };
    }
    const date = new Date(dateString);
    return date.toLocaleDateString(locale, options);
  },

  isPasswordValid: function(password) {
    return /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]).{8,}$/.test(
      password
    );
  },

  isValidUrl: function(str) {
    try {
      new URL(str);
      return true;
    } catch (_) {
      return false;
    }
  },

  sortAscending: function(data, onAttribute = "count") {
    if (onAttribute !== "count") {
      return data.sort(
        (a, b) => parseFloat(a[onAttribute]) - parseFloat(b[onAttribute])
      );
    }
    return data.sort((a, b) => parseFloat(a.count) - parseFloat(b.count));
  },

  sortDescending: function(data, onAttribute = "count") {
    return data.sort(
      (a, b) => parseFloat(b[onAttribute]) - parseFloat(a[onAttribute])
    );
  },

  checkTextIfHaveEmailOrPhone: function(text) {
    const regexPhone = /\d{9,}/g;
    const regexEmail = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;

    const havePhone = regexPhone.test(text.replace(/\s/g, ""));
    const haveEmail = regexEmail.test(text);

    return havePhone || haveEmail;
  },

  generateFunction: function(base64Pdf, filename) {
    // Decode base64 to binary
    const binaryString = window.atob(base64Pdf);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Create a Blob from the binary data
    const pdfBlob = new Blob([bytes], { type: "application/pdf" });

    // Create a link element
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(pdfBlob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  getMetaData: function(file, feature = null) {
    const fileName = file.name; // Name of the file
    const fileType = file.type; // File MIME type
    const fileSize = (file.size / 1024).toFixed(2); // File size in KB (rounded to 2 decimal places)

    return {
      name: fileName,
      type: fileType,
      size: `${fileSize} KB`,
    };
  },

  uploadFile: async function(
    url,
    fileObject,
    uploadedBy = null,
    servce = "FrontEnd",
    authenticated = false
  ) {
    const STORAGE_API_URL = process.env.REACT_APP_STORAGE_API_URL;
    const metadata = this.getMetaData(fileObject.file);
    const formData = new FormData();
    let token = localStorage.getItem("TOKEN_BEARER");
    metadata.uploadedBy = uploadedBy;

    formData.append(
      "replace_uuid",
      fileObject.replace_uuid === undefined ? null : fileObject.replace_uuid
    );
    formData.append("service_name", servce);
    formData.append("file", fileObject.file);
    formData.append("metadata", JSON.stringify(metadata));

    let uploadUrl = authenticated
      ? STORAGE_API_URL + "files/upload"
      : STORAGE_API_URL + "register/upload";
    return await axios.post(uploadUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
